export default "/assets/images/bigsneeze-circle.026b7ce97e085ed9.png";